import React, { useEffect, useState, useRef, useMemo } from "react";
import Loader from "../component/Loader";
import { Link } from "react-router-dom/cjs/react-router-dom";
import { getData } from "../store/utils";
import Swal from "sweetalert2";
import { useDebounce } from 'use-debounce';
import { useParams } from "react-router-dom";
import { IoClose } from 'react-icons/io5';


const customStyles = {
    content: {
        top: "50%",
        left: "50%",
        right: "auto",
        bottom: "auto",
        marginRight: "-50%",
        transform: "translate(-50%, -50%)",
        overflow: "none",
        padding: "0px",
        minWidth: "90%",
        maxWidth: "90%",
    },
};

function PurchanseReceiveDetails() {
    const [isLoadingOn, setIsLoadingOn] = useState(false);
    const { id } = useParams();
    const [orderList, setOrderList] = useState([]);
    const [selectedOrder, setSelectedOrder] = useState(null);
    const [orderDetails, setOrderDetails] = useState("");
    const [productList, setProductList] = useState([]);
    const [text, setText] = useState('');
    const [value] = useDebounce(text, 1000);

    useEffect(() => {
        // Call API with the order ID
        fetchOrderDetails(id);
    }, [id]);

    async function fetchOrderDetails(orderId) {
        setIsLoadingOn(true);
        const tempData = await getData(`inventory/getPurchaseReceiveDetails/${orderId}`);
        // const tempData = await res.json();
        setIsLoadingOn(false);
        // console.log("tempData++++", tempData)
        if (tempData?.statusCode === 200) {
            const records = tempData?.data;
            console.log(records)
            setProductList(records);
            setOrderDetails(records[0]);
            setSelectedOrder(records[0])
        } else {
            Swal.fire({
                title: "Error!",
                text: tempData?.data?.errors?.msg || "Something went wrong!!!"
            });
        }
    }

    async function getPurchaseOrder(typeValue) {
        setIsLoadingOn(true);
        const tempData = await getData(`inventory/getReceiveOrder`);
        setIsLoadingOn(false);

        if (tempData?.statusCode === 200) {
            const records = tempData?.data?.records;
            if (Array.isArray(records)) {
                setOrderList(records);
            } else {
                setOrderList([]);
            }
        } else {
            setOrderList([]); // ensure orderList is not undefined
            Swal.fire({
                title: "Error!",
                text: tempData?.data?.errors?.msg || "Something went wrong!!!"
            });
        }
    }

    // Debounced search
    useEffect(() => {
        getPurchaseOrder(value); // if empty string, returns all
    }, [value]);

    const totals = productList.reduce(
        (acc, item) => {
            const qty = Number(item?.quantity) || 0;
            const rate = Number(item?.rate) || 0;
            const discount = Number(item?.discount) || 0;
            const itemTotal = qty * rate - discount;

            acc.totalQuantity += qty;
            acc.subTotal += qty * rate;
            acc.totalDiscount += discount;
            acc.total += itemTotal;

            return acc;
        },
        { totalQuantity: 0, subTotal: 0, totalDiscount: 0, total: 0 }
    );

    console.log(orderList)

    return (
        <div className="purchaseOrderDetails" style={{ backgroundColor: "#fff", marginLeft: "-20px" }}>
            {isLoadingOn ? <Loader /> : ""}
            <div className="row ordersec">
                <div className="col-sm-3 lfsec pd0">
                    <div className="ps-3 pt-3 pb-3 d-flex justify-content-between">
                        <h5>All Purchase Receives</h5>
                        <Link to={'/purchasereceives'}>
                            <button className="btn btn-primary mx-2">
                                + New
                            </button>
                        </Link>
                    </div>
                    {
                        orderList.map((item, index) => {
                            const isSelected = selectedOrder?.purchaseOrderId === item?.purchaseOrderId;

                            return <div
                                className={`lfheader d-flex ${isSelected ? 'selected' : ''}`}
                                key={index}
                                onClick={() => {
                                    setSelectedOrder(item);
                                }}
                            >
                                <div>
                                    {/* <input type="checkbox" /> */}
                                </div>
                                <Link to={`/purchasereceiveDetails/${item.purchaseReceiveId}`} className="d-flex justify-content-between w-100">
                                    <div className="ms-3">
                                        <div className="hd">{item?.vendorName}</div>
                                        <div className="podate">{item?.purchaseOrder} <span className="mx-3">-</span> {item?.purchaseDate}</div>
                                        <div className="orderStatus">{item?.statusName}</div>
                                    </div>
                                    <div className="ms-auto amount">
                                        Rs.{item?.orderTotal ? Number(item.orderTotal).toFixed(2) : '0.00'}
                                    </div>
                                </Link>
                            </div>

                        })
                    }
                </div>


                <div className="col-sm-9 rtsec pd0">
                    {orderDetails && (
                        <div className="ps-4 pt-3 pb-3 d-flex">
                            <h5>{orderDetails.purchaseOrder}</h5>
                            <div className="ms-auto">
                                <Link to={'/purchasereceivesList'}><IoClose size={24} style={{ cursor: "pointer", color: "#666" }} /></Link>
                            </div>
                        </div>
                    )}
                    <ul className="d-flex">
                        <li>Edit</li>
                        <li>Send Email</li>
                        <li>PDF/Print</li>
                        <li>Receive</li>
                        <li>Convert to Bill</li>
                        <li>:</li>
                    </ul>
                    <div className="scroll-y noscroll-x fill body scrollbox">
                        {orderDetails && (
                            <div className="row">
                                <div className="col-lg-7 col-md-6">
                                    <h3 className="text-uppercase">Purchase Receive</h3>
                                    <div className="so-number">
                                        <label className="font-small">Receive#</label>
                                        <label className="font-small"><strong>{orderDetails?.purchaseReceive}</strong></label>
                                    </div>
                                    <div>
                                        <label className="text-uppercase text-semibold badge badge-so badge-open">{orderDetails?.statusName}</label>
                                    </div>
                                    <div className="order-info">
                                        {/* <div className="row">
                                            <div className="col-lg-4">
                                                <h6 className="text-uppercase"><strong>Reference#</strong></h6>
                                            </div>
                                            <div className="col-lg-6 so-details-label">{orderDetails?.reference}</div>
                                        </div> */}
                                        <div className="row">
                                            <div className="col-lg-4"><h6 className="text-uppercase"><strong>Purchase Order#</strong></h6></div>
                                            <div className="col-lg-6 so-details-label wordwrap">{orderDetails?.purchaseOrder}</div>
                                        </div>
                                        <div className="row">
                                            <div className="col-lg-4">
                                                <h6 className="text-uppercase"><strong>Order Date</strong></h6>
                                            </div>
                                            <div className="col-lg-6 so-details-label">{orderDetails?.purchaseDate}</div>
                                        </div>

                                    </div>
                                </div>
                                <div className="col-lg-5 col-md-6">
                                    <div className="address">
                                        <h6 className="text-uppercase"><strong>Vendor Name</strong></h6>
                                        <label><a id="ember303" className="ember-view" href="#">{orderDetails?.vendorName}</a></label>
                                    </div>
                                    {/* <div className="address mt-5">
                                        <h6 className="text-uppercase"><strong>Delivery Address</strong></h6>
                                        <address>{orderDetails?.deliveryAddress}</address>
                                    </div> */}


                                </div>
                            </div>
                        )}
                        <div className="orderTable">
                            <table style={{ width: "100%" }}>
                                <thead>
                                    <tr>
                                        <th>Items & Description	</th>
                                        <th>Ordered</th>
                                        <th>Received</th>
                                        <th>Previous Received</th>
                                        <th className="text-right">In Transit</th>
                                        <th className="text-right">Quantity to Receive</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {Array.isArray(productList) &&
                                        productList.map((item, index) => (
                                            <>
                                                <tr>
                                                    <td>
                                                        <div>{item?.productName}</div>
                                                    </td>
                                                    <td>
                                                        <div>{item?.ordered}</div>
                                                    </td>
                                                    <td>
                                                        <div>{item?.received}</div>

                                                    </td>
                                                    <td>
                                                        <div>{item?.previousReceived}</div>

                                                    </td>
                                                    <td>{item?.inTransit}</td>
                                                    <td>{item?.quantityToReceive}</td>
                                                </tr>
                                            </>
                                        ))
                                    }

                                </tbody>
                            </table>

                        </div>
                    </div>
                </div>


            </div>
        </div>
    );
}

export default PurchanseReceiveDetails;
